
import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/common/Logo";

interface SidebarLogoProps {
  isCollapsed: boolean;
}

const SidebarLogo: React.FC<SidebarLogoProps> = ({ isCollapsed }) => {
  return (
    <Link to="/app/dashboard">
      <Logo 
        size={isCollapsed ? "sm" : "md"} 
        showText={!isCollapsed}
      />
    </Link>
  );
};

export default SidebarLogo;
